import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { addFechasIngresosFinalAction, addFechasIngresosIncioAction } from "../../../ducks/reportesDuck"
import { Grid, MenuItem, FormControl, InputLabel, Select } from "@material-ui/core"
import PickerMod from "../../../global/PickersMod"
import { endMounth, esFechaValida, startMounth } from "../../../utils/FormatFecha"

const CabeceraIngresos = () => {
    const dispatch = useDispatch()
    const { ingresoFechaFin, ingresoFechaIncio } = useSelector(store => store.reportes)
    const [tipoBusqueda, setTipoBusqueda] = useState("0")
    const handleChange = (event) => {
        setTipoBusqueda(event.target.value)
    }
    const handleChangeFechaMesFin = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        const fechaFin = endMounth({ date })
        dispatch(addFechasIngresosFinalAction({ FechaFin: fechaFin }))
    }
    const handleChangeFechaMesIncio = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        const fechaInicio = startMounth({ date })
        dispatch(addFechasIngresosIncioAction({ FechaIni: fechaInicio }))
    }
    const handleClickSelecFechaInicio = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        dispatch(addFechasIngresosIncioAction({ FechaIni: date }))
    }
    const handleClickSelecFechaFinal = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        dispatch(addFechasIngresosFinalAction({ FechaFin: date }))
    }
    return (
        <>
            <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                <Grid item xs={4}>
                    <div>
                        <FormControl variant="outlined" style={{ width: "100%", margin: "1rem" }}>
                            <InputLabel id="lEstatus">Buscar por</InputLabel>
                            <Select
                                labelId="lTipoBusquedaIngreso"
                                id="STipoBusquedaIngreso"
                                name="tipoBusquedaingreso"
                                value={tipoBusqueda}
                                onChange={handleChange}
                                label="Buscar por"
                            >
                                <MenuItem value="0">
                                    {"Intervalo de fechas"}
                                </MenuItem>
                                <MenuItem value="1">
                                    {"Mes"}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </Grid>
            </Grid>
            <Grid container spacing={1} alignItems="center">
                <Grid item xs={3}>
                    <PickerMod
                        id="fechaIncioIngresos"
                        label="Desde"
                        selectedDate={ingresoFechaIncio}
                        setSelectedDate={(tipoBusqueda === "0" ? handleClickSelecFechaInicio : handleChangeFechaMesIncio)}
                        disablePast={false}
                        disableFuture={true}
                        formatFecha={tipoBusqueda === "0" ? "dd/MM/yyyy" : "MM/yyyy"}
                        views={tipoBusqueda === "0" ? ["year", "month", "date"] : ["year", "month"]}
                    />
                </Grid>
                <Grid item xs={3}>
                    <PickerMod
                        id="fechaFinalIngresos"
                        label="Hasta"
                        selectedDate={ingresoFechaFin}
                        setSelectedDate={(tipoBusqueda === "0" ? handleClickSelecFechaFinal : handleChangeFechaMesFin)}
                        disablePast={false}
                        disableFuture={tipoBusqueda === "0"}
                        formatFecha={tipoBusqueda === "0" ? "dd/MM/yyyy" : "MM/yyyy"}
                        views={tipoBusqueda === "0" ? ["year", "month", "date"] : ["year", "month"]}
                    />
                </Grid>
            </Grid>
        </>

    )
}
export default CabeceraIngresos